import React from "react";

const PromoRadioUncheckedIcon = props => (
  <svg width={24} height={24} {...props}>
    <rect
      x={18}
      y={50}
      width={22}
      height={22}
      rx={11}
      transform="translate(-17 -49)"
      stroke="#E6E6E6"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);

export default PromoRadioUncheckedIcon;


// WEBPACK FOOTER //
// ./src/components/CRM/Form/Icons/PromoRadioUnchecked.js